// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".infoContainer[data-v-30420336]{padding:10px 0}.infoContainer .top p[data-v-30420336]{text-align:center;margin:0}[data-v-30420336]:export{green:#3f9775;white:#fff}", ""]);
// Exports
module.exports = exports;
